import React from 'react'
import View from './view'

const CommunitySinglePublic = ({ ...props }) => {
    return <View {...props} />
}

export default CommunitySinglePublic
